// extracted by mini-css-extract-plugin
module.exports = {"heading":"discoverAdsFeature_heading__1zTY0","clearFilter":"discoverAdsFeature_clearFilter__3MPYn","tabsContainer":"discoverAdsFeature_tabsContainer__2jqWd"};